<script>
import { computed, defineAsyncComponent } from '@vue/runtime-core'
import { useStore } from 'vuex'
import _ from 'lodash'
// Load layout components dynamically.
const requireContext = require.context('~/pages/system/steps', false, /.*\.vue$/, 'sync')
const componentNames = requireContext.keys().map((file) => file.replace(/(^.\/)|(\.vue$)/g, ''))
const components = {}
componentNames.forEach((component) => { // component represents the component name
  components[component] = defineAsyncComponent({
    loader: () => import('@/pages/system/steps/' + component + '.vue'),
    delay: 0
  })
})
export default {
  components,
  setup () {
    const store = useStore()
    const currentStepType = computed(() => {
      return slugify(store.getters['system/currentStep'].type)
    })
    function slugify (str) {
      if (typeof str !== 'undefined') {
        return str.toLowerCase()
          .replace(/[-_]+/g, ' ')
          .replace(/[^\w\s]/g, '')
          .replace(/ (.)/g, function ($1) { return $1.toUpperCase() })
          .replace(/ /g, '')
      }
    }
    const menu = computed(() => _.orderBy(store.getters['system/menu'] || [], 'sort'))
    const currentStep = computed(() => store.getters['system/currentStep'])
    const hasNextStep = computed(() => {
      const steps = menu.value
      const index = steps.findIndex(step => step.id === currentStep.value?.id)
      return index >= 0 && index < steps.length - 1
    })
    function nextStep () {
      const steps = menu.value
      const index = steps.findIndex(step => step.id === currentStep.value?.id)
      const next = steps[index + 1]
      if (next) {
        store.dispatch('system/setCurrentStep', next.id)
      }
    }
    return {
      currentStepType,
      currentStep,
      hasNextStep,
      nextStep
    }
  }
}
</script>
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <Component v-if="currentStepType" :is="currentStepType" />
        <div class="text-center mb-2 mt-2">
          <button v-if="hasNextStep" class="btn btm-sm btn-outline-primary" type="button" @click="nextStep" id="btn-scroll" :data-id="currentStep && currentStep.id">zum nächsten Schritt <i class="fas fa-arrow-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</template>
